<template>
  <div>
    <!-- -->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="40%" modal-append-to-body append-to-body
      close-on-click-modal @closed="handleClose">
      <el-form size="small" :model="form" :rules="rules" ref="form" label-width="180px"
        :validate-on-rule-change="false">
        <!-- 协议名称 -->
        <el-form-item label="协议名称" prop="agreementName">
          <el-select :disabled="optionType === 'view'" size="small" v-model="form.agreementName" placeholder="请选择协议名称"
            @change="agreementChange" style="width: 100%;;margin-right: 20px;" clearable>
            <el-option v-for="(item, index) in protocolList.value" :key="index" :label="item.name"
              :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- 协议版本 -->
        <el-form-item label="协议版本" prop="agreementVersion">
          <el-select :disabled="optionType === 'view'" size="small" v-model="form.agreementVersion"
            placeholder="请选择协议版本" @change="versionChange" style="width: 100%;;margin-right: 20px;" clearable>
            <el-option v-for="(item, index) in agreementVersion" :key="index" :label="item.agreementVersion"
              :value="item.agreementVersion"></el-option>
          </el-select>
        </el-form-item>
        <!-- 渠道选择 必填、radio单选 -->
        <el-form-item label="渠道选择" prop="channelType">
          <el-radio-group v-model="form.channelType">
            <el-radio :label="1">全部渠道</el-radio>
            <el-radio :label="2">指定渠道</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 指定渠道 -->
        <el-form-item v-if="form.channelType === 2" label="指定渠道" prop="channelIds">
          <el-input type="textarea" @focus="channelInputClick(item)" v-model="form.channelIds">
          </el-input>
          <channel-popups :isAppendToBody="true" :modelIsAppendToBody="false" :app-id="form.channels.channelId"
            :visible.sync="channelVisible" @comfirm="channelConfirm($event, item)" :multiple="true"></channel-popups>
        </el-form-item>
        <!-- 发端 -->
        <el-form-item label="发端" prop="senderPlatforms">
          <el-checkbox-group v-model="senderPlatforms" @change="senderPlatformsChange">
            <el-checkbox v-for="item in sendPlatform.value" :key="item.value" :label="item.value">{{ item.label
              }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!-- 收端 -->
        <el-form-item label="收端" prop="receiverPlatforms">
          <el-checkbox-group v-model="receiverPlatforms" @change="receiverPlatformsChange">
            <el-checkbox v-for="item in receivePlatform.value" :key="item" :label="item.value">{{ item.label
              }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!-- 发端客户端版本 -->
        <el-form-item v-for="(senderPlatform, index) in form.senderPlatforms" :key="index"
          :label="`发端 ${senderPlatform.label}版本`" :prop="`senderPlatforms.${index}.minClientVersion`">
          <div style="display: flex;">
            <el-input style="margin-right: 10px;" size="small" v-model="senderPlatform.minClientVersion" maxlength="200"
              placeholder="请输入最小版本" clearable></el-input>
            <el-input size="small" v-model="senderPlatform.maxClientVersion" maxlength="200" placeholder="请输入最大版本"
              clearable></el-input>
          </div>
        </el-form-item>
        <!-- 收端客户端版本 -->
        <el-form-item v-for="(receiverPlatform, index) in form.receiverPlatforms" :key="index"
          :label="`收端 ${receiverPlatform.label}版本`" :prop="`receiverPlatforms.${index}.minClientVersion`">
          <div style="display: flex;">
            <el-input style="margin-right: 10px;" size="small" v-model="receiverPlatform.minClientVersion"
              maxlength="200" placeholder="请输入最小版本" clearable></el-input>
            <el-input size="small" v-model="receiverPlatform.maxClientVersion" maxlength="200" placeholder="请输入最大版本"
              clearable></el-input>
          </div>
        </el-form-item>
        <!-- <el-form-item label="客户端版本" prop="minClientVersion">
          <div style="display: flex;">
            <el-input style="margin-right: 10px;" size="small" v-model="form.minClientVersion" maxlength="200"
              placeholder="请输入最小版本" clearable></el-input>
            <el-input size="small" v-model="form.maxClientVersion" maxlength="200" placeholder="请输入最大版本"
              clearable></el-input>
          </div>
        </el-form-item> -->
        <!-- 说明 -->
        <el-form-item label="说明" prop="remark">
          <el-input size="small" v-model="form.remark" maxlength="200" placeholder="请输入说明" clearable></el-input>
        </el-form-item>
        <!-- 是否需要弹窗 0：否 1：是 -->
        <el-form-item label="是否需要弹窗" prop="popup">
          <el-radio-group v-model="form.popup">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 协议地址 -->
        <el-form-item label="协议地址">
          <span>{{ form.agreementUrl }}</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
    <Publish ref="publish" @isSubmit="submitChange"></Publish>
  </div>
</template>

<script>
import {
  addProtocolUpdate,
  getProtocolUpdateInfo,
  updateProtocolUpdate
} from "@/api/protocolCompliance/protocolUpdate";
import ChannelPopups from "@/components/channel-popups";
import Message from "@/components/Message";
import Publish from "./publish.vue";
export default {
  name: "WebSaaSAdd",
  inject: ["protocolList", "loadList", "sendPlatform", "receivePlatform"],
  components: {
    Publish,
    ChannelPopups
  },
  computed: {
    title() {
      return this.optionType === "add" ? "新增协议" : "查看协议";
    },
    rules() {
      const rules = {
        agreementName: [
          { required: true, message: "请选择协议名称", trigger: "blur" }
        ],
        agreementVersion: [
          { required: true, message: "请选择协议版本", trigger: "blur" }
        ],
        senderPlatforms: {
          validator: (rule, value, callback) => {
            /** 收发端选择一个即可 */
            if (
              this.form.receiverPlatforms.length === 0 &&
              this.form.senderPlatforms.length === 0
            ) {
              callback(new Error("收发端至少选择一个"));
            } else {
              callback();
            }
          },
          trigger: "change"
        },
        receiverPlatforms: {
          validator: (rule, value, callback) => {
            /** 收发端选择一个即可 */
            if (
              this.form.receiverPlatforms.length === 0 &&
              this.form.senderPlatforms.length === 0
            ) {
              callback(new Error("收发端至少选择一个"));
            } else {
              callback();
            }
          },
          trigger: "change"
        },
        channelType: [
          { required: true, message: "请选择渠道类型", trigger: "blur" }
        ],
        channelIds: [
          { required: true, message: "请选择渠道", trigger: "blur" }
        ],
        popup: [
          { required: true, message: "请选择是否需要弹窗", trigger: "blur" }
        ]
      };
      this.form.senderPlatforms.forEach((item, index) => {
        rules.senderPlatforms[index] = {
          minClientVersion: [
            {
              required: true,
              validator: (rule, value, callback) => {
                const minVersion = item.minClientVersion;
                const maxVersion = item.maxClientVersion;

                // 如果两个字段都为空，验证通过
                if (!minVersion && !maxVersion) {
                  callback();
                  return;
                }

                // 验证格式
                // 允许数字
                const versionPattern = /^\d+$/;
                let formatError = false;
                if (minVersion && !versionPattern.test(minVersion)) {
                  formatError = true;
                  callback(new Error("请输入正确格式的最小版本号"));
                }
                if (maxVersion && !versionPattern.test(maxVersion)) {
                  formatError = true;
                  callback(new Error("请输入正确格式的最大版本号"));
                }

                // 如果格式有误，不再进行其他验证
                if (formatError) return;

                // 如果同时填写了最小版本和最大版本，检查大小关系
                if (minVersion && maxVersion && minVersion > maxVersion) {
                  callback(new Error("最小版本号必须小于等于最大版本号"));
                  return;
                }

                // 所有验证通过
                callback();
              },
              trigger: "blur"
            }
          ]
        };
      });
      this.form.receiverPlatforms.forEach((item, index) => {
        rules.receiverPlatforms[index] = {
          minClientVersion: [
            {
              required: true,
              validator: (rule, value, callback) => {
                const minVersion = item.minClientVersion;
                const maxVersion = item.maxClientVersion;

                // 如果两个字段都为空，验证通过
                if (!minVersion && !maxVersion) {
                  callback();
                  return;
                }

                // 验证格式
                // 允许数字
                const versionPattern = /^\d+$/;
                let formatError = false;
                if (minVersion && !versionPattern.test(minVersion)) {
                  formatError = true;
                  callback(new Error("请输入正确格式的最小版本号"));
                }
                if (maxVersion && !versionPattern.test(maxVersion)) {
                  formatError = true;
                  callback(new Error("请输入正确格式的最大版本号"));
                }

                // 如果格式有误，不再进行其他验证
                if (formatError) return;

                // 如果同时填写了最小版本和最大版本，检查大小关系
                if (minVersion && maxVersion && minVersion > maxVersion) {
                  callback(new Error("最小版本号必须小于等于最大版本号"));
                  return;
                }

                // 所有验证通过
                callback();
              },
              trigger: "blur"
            }
          ]
        };
      });
      console.log("rules", rules);
      return rules;
    },
  },
  data() {
    return {
      /** 渠道选择框 */
      channelVisible: false,
      /** 是否确认发布 */
      isSubmit: false,
      /** 收端客户端数组 */
      receiverPlatforms: [],
      /** 发端客户端数组 */
      senderPlatforms: [],
      /** 操作类型 */
      optionType: "add",
      dialogVisible: false,
      /** 协议版本选择数组 */
      agreementVersion: [],
      form: {
        /** 协议名称 */
        agreementName: "",
        /** 协议版本 */
        agreementVersion: "",
        /** 渠道 */
        channels: {
          channelId: "",
          channelName: ""
        },
        /** 渠道选择 */
        channelType: "",
        /** 指定渠道 */
        channelIds: "",
        /** 收端 */
        receiverPlatforms: [],
        /** 发端 */
        senderPlatforms: [],
        /** 是否需要弹窗 */
        popup: '',
        /** 说明 */
        remark: "",
        /** 最大版本 */
        maxClientVersion: "",
        /** 最小版本 */
        minClientVersion: "",
        /** 协议地址 */
        agreementUrl: "",
        /** 协议模板编码 */
        agreementCode: "",
        /** 协议id */
        agreementId: ""
      },
      /** 富文本配置 */
      options: {}
    };
  },
  methods: {
    /** 点击渠道选择框 */
    channelInputClick(item) {
      console.log("点击渠道选择框", item);
      this.channelVisible = true;
    },
    /** 确认渠道选择 */
    channelConfirm($event, item) {
      console.log("渠道选择的数据", $event, item);
      const { appId, nameStr } = $event;
      this.form.channels.channelId = appId;
      this.form.channels.channelName = nameStr;
      const idAry = appId.split(",");
      const nameAry = nameStr.split(",");
      const channelIds = idAry.map((item, index) => {
        return `[${item}] ${nameAry[index]}`;
      });
      this.$set(this.form, 'channelIds', channelIds)
    },
    /** 发端客户端选择变更 */
    senderPlatformsChange(val) {
      console.log("senderPlatformsChange", val);

      // 保留之前的版本信息
      const previousPlatforms = this.form.senderPlatforms.reduce((acc, platform) => {
        acc[platform.platformType] = platform;
        return acc;
      }, {});

      // 更新 senderPlatforms
      this.form.senderPlatforms = val.map(item => {
        // 如果该 platformType 已存在于 previousPlatforms 中，保留其版本信息
        const existingPlatform = previousPlatforms[item] || {};

        return {
          platformType: item,
          minClientVersion: existingPlatform.minClientVersion || "",
          maxClientVersion: existingPlatform.maxClientVersion || "",
          label: this.getLabel(item, this.sendPlatform.value)
        };
      });
    }
    ,
    /** 收端客户端选择变更 */
    receiverPlatformsChange(val) {
      console.log("receiverPlatformsChange", val);

      // 构建之前平台的映射，用于保留 minClientVersion 和 maxClientVersion
      const previousPlatforms = this.form.receiverPlatforms.reduce((acc, platform) => {
        acc[platform.platformType] = platform;
        return acc;
      }, {});

      // 更新 receiverPlatforms
      this.form.receiverPlatforms = val.map(item => {
        // 如果该 platformType 已存在于 previousPlatforms 中，保留其版本信息
        const existingPlatform = previousPlatforms[item] || {};

        return {
          platformType: item,
          minClientVersion: existingPlatform.minClientVersion || "",
          maxClientVersion: existingPlatform.maxClientVersion || "",
          label: this.getLabel(item, this.receivePlatform.value)
        };
      });
    }
    ,
    /** 协议选择变更的事件 */
    async agreementChange(newValue) {
      console.log("协议选择变更的事件", newValue);
      if (newValue) {
        const code = this.protocolList.value.find(
          item => item.name === newValue
        ).code;
        const { data } = await getProtocolUpdateInfo(code);
        console.log("根据协议code查询详细信息的响应", data);
        /** 如果没有信息就是没有申请协议
         *  提示用户
         */
        if (data.data.length === 0) {
          /** 协议版本置为空 */
          this.agreementVersion = [];
          Message.error("该协议没有申请协议,请先申请协议");
        } else {
          this.agreementVersion = data.data.map(item => {
            return {
              agreementCode: item.code,
              agreementId: item.id,
              agreementUrl: item.url,
              agreementVersion: item.version
            };
          });
        }
      }

      // this.form.agreementCode = agreement.code;
      // this.form.agreementId = agreement.id;
      // this.form.agreementUrl = agreement.url;
    },
    /** 选择协议版本事件 */
    versionChange(newValue) {
      console.log("选择协议版本事件", newValue);
      if (newValue) {
        /** 选择了对应的版本之后，得到对应版本的协议信息 */
        const agreement = this.agreementVersion.find(
          item => item.agreementVersion === newValue
        );
        this.form.agreementCode = agreement.agreementCode;
        this.form.agreementId = agreement.agreementId;
        this.form.agreementUrl = agreement.agreementUrl;
      }
    },
    /** 确认保存的事件 */
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          console.log("表单验证通过");
          console.log("this.form", this.form);
          /** 增加是否发布的二次询问 */
          this.$refs.publish.show();
        } else {
          console.log("表单验证失败");
          return false;
        }
      });
    },
    /** 新增的方法 */
    async add() {
      console.log("新增");
      const params = {
        ...this.form,
        agreementId: Number(this.form.agreementId),
        /** 收发端版本传int */
        receiverPlatforms: this.form.receiverPlatforms.map(item => {
          return {
            ...item,
            minClientVersion: item.minClientVersion
              ? Number(item.minClientVersion)
              : null,
            maxClientVersion: item.maxClientVersion
              ? Number(item.maxClientVersion)
              : null
          };
        }),
        senderPlatforms: this.form.senderPlatforms.map(item => {
          return {
            ...item,
            minClientVersion: item.minClientVersion
              ? Number(item.minClientVersion)
              : null,
            maxClientVersion: item.maxClientVersion
              ? Number(item.maxClientVersion)
              : null
          };
        })
      };
      const channelAry = [
        {
          channelId: 0,
          channelName: "全部渠道"
        }
      ];
      /** 全部渠道时，ids列表为[0] */
      if (params.channelType === 1) {
        params.channels = channelAry;
      } else if (params.channelType === 2) {
        const nameAry = this.form.channels.channelName.split(",");
        /** 指定渠道时，ids列表为指定的渠道 */
        params.channels = this.form.channels.channelId
          .split(",")
          .map((item, index) => {
            return {
              channelId: Number(item),
              channelName: nameAry[index]
            };
          });
      }
      const { data } = await addProtocolUpdate(params);
      console.log("新增的响应", data);
      if (data.code === 200) {
        Message.success("新增成功");
        this.loadList();
        this.hide();
      }
    },
    /** 编辑的方法 */
    async edit() {
      console.log("编辑");
      const params = {
        ...this.form,
        agreementId: Number(this.form.agreementId),
        /** 收发端版本传int */
        receiverPlatforms: this.form.receiverPlatforms.map(item => {
          return {
            ...item,
            minClientVersion: item.minClientVersion
              ? Number(item.minClientVersion)
              : null,
            maxClientVersion: item.maxClientVersion
              ? Number(item.maxClientVersion)
              : null
          };
        }),
        senderPlatforms: this.form.senderPlatforms.map(item => {
          return {
            ...item,
            minClientVersion: item.minClientVersion
              ? Number(item.minClientVersion)
              : null,
            maxClientVersion: item.maxClientVersion
              ? Number(item.maxClientVersion)
              : null
          };
        })
      };
      const channelAry = [
        {
          channelId: 0,
          channelName: "全部渠道"
        }
      ];
      /** 全部渠道时，ids列表为[0] */
      if (params.channelType === 1) {
        params.channels = channelAry;
      } else if (params.channelType === 2) {
        const nameAry = this.form.channels.channelName.split(",");
        /** 指定渠道时，ids列表为指定的渠道 */
        params.channels = this.form.channels.channelId
          .split(",")
          .map((item, index) => {
            return {
              channelId: Number(item),
              channelName: nameAry[index]
            };
          });
      }
      const { data } = await updateProtocolUpdate(params);
      console.log("编辑的响应", data);
      if (data.code === 200) {
        Message.success("编辑成功");
        this.loadList();
        this.hide();
      }
    },
    /** 根据value返回对应的label值 */
    getLabel(value, ary) {
      const res = ary.find(item => item.value == value);
      return res ? res.label : "";
    },
    //^ ^--------------对话框自身的方法-------------^ ^
    /** 发布 */
    submitChange(submit) {
      this.isSubmit = submit;
      if (submit) {
        if (this.optionType === "add") {
          this.add();
        } else {
          this.edit();
        }
      }
    },
    show(optionType, row) {
      this.optionType = optionType || "add";
      if (row) {
        const channelAry = [
          {
            channelId: 0,
            channelName: "全部渠道"
          }
        ];
        this.form = {
          id: Number(row.id),
          agreementName: row.agreementName,
          agreementVersion: row.agreementVersion,
          receiverPlatforms: row.receiverPlatforms.map(item => {
            return {
              platformType: item.platformType,
              minClientVersion: item.minClientVersion,
              maxClientVersion: item.maxClientVersion,
              label: this.getLabel(item.platformType, this.receivePlatform.value)
            };
          }),
          senderPlatforms: row.senderPlatforms.map(item => {
            return {
              platformType: item.platformType,
              minClientVersion: item.minClientVersion,
              maxClientVersion: item.maxClientVersion,
              label: this.getLabel(item.platformType, this.sendPlatform.value)
            };
          }),
          remark: row.remark,
          agreementUrl: row.agreementUrl,
          agreementCode: row.agreementCode,
          agreementId: row.agreementId,
          channelType: row.channelType,
          popup: row.popup
        };
        if (this.form.channelType === 1) {
          this.form.channels = channelAry[0];
        } else if (this.form.channelType === 2) {
          this.form.channels = {
            channelId: row.channels.map(item => item.channelId).join(","),
            channelName: row.channels.map(item => item.channelName).join(",")
          };
          this.form.channelIds = row.channels
            .map(item => `[${item.channelId}] ${item.channelName}`)
            .join(",");
        }
        /**处理收发客户端回填选中 */
        this.receiverPlatforms = row.receiverPlatforms.map(
          item => item.platformType
        );
        this.senderPlatforms = row.senderPlatforms.map(item => item.platformType);
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.validate();
        });
      }
      this.$nextTick(() => {
        this.dialogVisible = true;
      });
    },
    hide() {
      this.dialogVisible = false;
    },
    handleClose() {
      /** 重置表单 */
      this.form = {
        /** 协议名称 */
        agreementName: "",
        /** 协议版本 */
        agreementVersion: "",
        /** 渠道 */
        channels: {
          channelId: "",
          channelName: ""
        },
        /** 渠道选择 */
        channelType: "",
        /** 指定渠道 */
        channelIds: "",
        /** 收端 */
        receiverPlatforms: [],
        /** 发端 */
        senderPlatforms: [],
        /** 是否需要弹窗 */
        popup: '',
        /** 说明 */
        remark: "",
        /** 最大版本 */
        maxClientVersion: "",
        /** 最小版本 */
        minClientVersion: "",
        /** 协议地址 */
        agreementUrl: "",
        /** 协议模板编码 */
        agreementCode: "",
        /** 协议id */
        agreementId: ""
      };
      this.senderPlatforms = [];
      this.receiverPlatforms = [];
      /** 清除验证规则 */
      this.$refs.form.clearValidate();
    },

  }
};
</script>

<style lang="scss" scoped></style>
